export default __webpack_public_path__ + "static/media/pageFlipSound.ca2b72e4.mp3";